export const translations = {
  HELLO: 'HELLO',
  LANGUAGE: 'LANGUAGE',
  INCORRECTMAIL: 'INCORRECTMAIL',
  LOGIN: 'LOGIN',
  TITLE: 'TITLE',
  EMAIL: 'EMAIL',
  CHOOSE: 'CHOOSE',
  EMAIL_PLACEHOLDER: 'EMAIL_PLACEHOLDER',
  PASSWORD: 'PASSWORD',
  PASSWORD_PLACEHOLDER: 'PASSWORD_PLACEHOLDER',
  FIRSTNAME: 'FIRSTNAME',
  FIRSTNAME_PLACEHOLDER: 'FIRSTNAME_PLACEHOLDER',
  LASTNAME: 'LASTNAME',
  LASTNAME_PLACEHOLDER: 'LASTNAME_PLACEHOLDER',
  FULLNAME: 'FULLNAME',
  FULLNAME_PLACEHOLDER: 'FULLNAME_PLACEHOLDER',
  SOCIETY: 'SOCIETY',
  SOCIETY_PLACEHOLDER: 'SOCIETY_PLACEHOLDER',
  COMPANY: 'COMPANY',
  COMPANY_PLACEHOLDER: 'COMPANY_PLACEHOLDER',
  REMEMBER_ME: 'REMEMBER_ME',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  AGREE_CONDITION: 'AGREE_CONDITION',
  LOGIN_BUTTON: 'LOGIN_BUTTON',
  CONFIRM_BUTTON: 'CONFIRM_BUTTON',
  REGISTER_ACCOUNT_BUTTON: 'REGISTER_ACCOUNT_BUTTON',
  RETURN_BUTTON: 'RETURN_BUTTON',
  SIGNATURE_CONFIRMED: 'SIGNATURE_CONFIRMED',
  SIGNATURE_TITLE: 'SIGNATURE_TITLE',
  REGISTER_TITLE: 'REGISTER_TITLE',
  HOME_TITLE: 'HOME_TITLE',
  HOME_BLOCK_TITLE: 'HOME_BLOCK_TITLE',
  HOME_SUBTITLE: 'HOME_SUBTITLE',
  APPOINTMENT_TITLE: 'APPOINTMENT_TITLE',
  APPOINTMENT_BLOCK_TITLE: 'APPOINTMENT_BLOCK_TITLE',
  APPOINTMENT_SUBTITLE: 'APPOINTMENT_SUBTITLE',
  APPOINTMENT_SUBTITLE2: 'APPOINTMENT_SUBTITLE2',
  APPOINTMENT_SUBTITLE3: 'APPOINTMENT_SUBTITLE3',
  APPOINTMENT_ADD_BUTTON: 'APPOINTMENT_ADD_BUTTON',
  MEETING_TITLE: 'MEETING_TITLE',
  MEETING_BLOCK_TITLE: 'MEETING_BLOCK_TITLE',
  MEETING_SUBTITLE: 'MEETING_SUBTITLE',
  MEETING_SUBTITLE2: 'MEETING_SUBTITLE2',
  CONCIERGE_SERVICE_TITLE: 'CONCIERGE_SERVICE_TITLE',
  CONCIERGE_BLOCK_TITLE: 'CONCIERGE_BLOCK_TITLE',
  CONCIERGE_SUBTITLE: 'CONCIERGE_SUBTITLE',
  PARCEL_TITLE: 'PARCEL_TITLE',
  PARCEL_BLOCK_TITLE: 'PARCEL_BLOCK_TITLE',
  PARCEL_SUBTITLE: 'PARCEL_SUBTITLE',
  EVENT_TITLE: 'EVENT_TITLE',
  EVENT_BLOCK_TITLE: 'EVENT_BLOCK_TITLE',
  EVENT_SUBTITLE: 'EVENT_SUBTITLE',
  GYM_TITLE: 'GYM_TITLE',
  GYM__BLOCK_TITLE: 'GYM__BLOCK_TITLE',
  GYM__SUBTITLE: 'GYM__SUBTITLE',
  BEAUTY_ROOM_TITLE: 'BEAUTY_ROOM_TITLE',
  BEAUTY_ROOM_BLOCK_TITLE: 'BEAUTY_ROOM_BLOCK_TITLE',
  BEAUTY_ROOM_SUBTITLE: 'BEAUTY_ROOM_SUBTITLE',
  PROFILE_TITLE: 'PROFILE_TITLE',
  PROFILE_SUBTITLE: 'PROFILE_SUBTITLE',
  PARKING_TITLE: 'PARKING_TITLE',
  PARKING_BLOCK_TITLE: 'PARKING_BLOCK_TITLE',
  PARKING_SUBTITLE: 'PARKING_SUBTITLE',
  CYD_BLOCK_TITLE: 'CYD_BLOCK_TITLE',
  CYD_SUBTITLE: 'CYD_SUBTITLE',
  FOODLES_BLOCK_TITLE: 'FOODLES_BLOCK_TITLE',
  FOODLES_SUBTITLE: 'FOODLES_SUBTITLE',
  WORKLIB_BLOCK_TITLE: 'WORKLIB_BLOCK_TITLE',
  WORKLIB_SUBTITLE: 'WORKLIB_SUBTITLE',
  ONEFLEX_BLOCK_TITLE: 'ONEFLEX_BLOCK_TITLE',
  ONEFLEX_SUBTITLE: 'ONEFLEX_SUBTITLE',
  RESTAURATION_BLOCK_TITLE: 'RESTAURATION_BLOCK_TITLE',
  RESTAURATION_SUBTITLE: 'RESTAURATION_SUBTITLE',
  ATRIUM_BLOCK_TITLE: 'ATRIUM_BLOCK_TITLE',
  ATRIUM_SUBTITLE: 'ATRIUM_SUBTITLE',
  LECOINTRE_BLOCK_TITLE: 'LECOINTRE_BLOCK_TITLE',
  LECOINTRE_SUBTITLE: 'LECOINTRE_SUBTITLE',
  LOGOUT_TITLE: 'LOGOUT_TITLE',
  DATE_BUTTON_OPEN: 'DATE_BUTTON_OPEN',
  DATE_BUTTON_CLOSE: 'DATE_BUTTON_CLOSE',
  SEARCH: 'SEARCH',
  VISITOR: 'VISITOR',
  TIME: 'TIME',
  DATE: 'DATE',
  RESIDENT: 'RESIDENT',
  CHECKIN: 'CHECKIN',
  COMPANY_NAME: 'COMPANY_NAME',
  VISITOR_EMAIL: 'VISITOR_EMAIL',
  VISITOR_EMAIL_LABEL: 'VISITOR_EMAIL_LABEL',
  NO_EMAIL: 'NO_EMAIL',
  LANGUAGE_MAIL: 'LANGUAGE_MAIL',
  LANGUAGE_MAIL_FR: 'LANGUAGE_MAIL_FR',
  LANGUAGE_MAIL_EN: 'LANGUAGE_MAIL_EN',
  VISITOR_ENTREPRISE: 'VISITOR_ENTREPRISE',
  VISITOR_ENTREPRISE_LABEL: 'VISITOR_ENTREPRISE_LABEL',
  COMMENTARY: 'COMMENTARY',
  NDA_STATUS: 'NDA_STATUS',
  EDIT: 'EDIT',
  EDIT_AND_SEND_EMAIL: 'EDIT_AND_SEND_EMAIL',
  DELETE: 'DELETE',
  CANCEL: 'CANCEL',
  CLOSE: 'CLOSE',
  CHECKIN_STATUS1: 'CHECKIN_STATUS1',
  CHECKIN_STATUS2: 'CHECKIN_STATUS2',
  CHECKIN_STATUS3: 'CHECKIN_STATUS3',
  CHECKIN_STATUS4: 'CHECKIN_STATUS4',
  APPOINTMENT_MODAL_TITLE: 'APPOINTMENT_MODAL_TITLE',
  APPOINTMENT_MODAL_TITLE2: 'APPOINTMENT_MODAL_TITLE2',
  APPOINTMENT_MODAL_LAST_NAME: 'APPOINTMENT_MODAL_LAST_NAME',
  APPOINTMENT_MODAL_LAST_NAME_LABEL: 'APPOINTMENT_MODAL_LAST_NAME_LABEL',
  APPOINTMENT_MODAL_LAST_NAME_ERROR: 'APPOINTMENT_MODAL_LAST_NAME_ERROR',
  APPOINTMENT_MODAL_FIRST_NAME: 'APPOINTMENT_MODAL_FIRST_NAME',
  APPOINTMENT_MODAL_FIRST_NAME_LABEL: 'APPOINTMENT_MODAL_FIRST_NAME_LABEL',
  APPOINTMENT_MODAL_FIRST_NAME_ERROR: 'APPOINTMENT_MODAL_FIRST_NAME_ERROR',
  APPOINTMENT_MODAL_CONFIRM_MESSAGE: 'APPOINTMENT_MODAL_CONFIRM_MESSAGE',
  EMAIL_ERROR: 'EMAIL_ERROR',
  ENTREPRISE_ERROR: 'EMAIL_ERROR',
  CREATE_BUTTON: 'CREATE_BUTTON',
  ADD_ANOTHER: 'ADD_ANOTHER',
  CLOSE_BUTTON: 'CLOSE_BUTTON',
  APPOINTMENT_CONFIRM: 'APPOINTMENT_CONFIRM',
  APPOINTMENT_EDIT_CONFIRM: 'APPOINTMENT_EDIT_CONFIRM',
  APPOINTMENT_ERROR: 'APPOINTMENT_ERROR',
  APPOINTMENT_INFO_DNA: 'APPOINTMENT_INFO_DNA',
  APPOINTMENT_INFO: 'APPOINTMENT_INFO',
  APPOINTMENT_COMMENT: 'APPOINTMENT_COMMENT',
  APPOINTMENT_COMMENT1: 'APPOINTMENT_COMMENT1',
  APPOINTMENT_COMMENT2: 'APPOINTMENT_COMMENT2',
  APPOINTMENT_COMMENT3: 'APPOINTMENT_COMMENT3',
  APPOINTMENT_DELETE: 'APPOINTMENT_DELETE',
  APPOINTMENT_DELETE2: 'APPOINTMENT_DELETE2',
  MEETING_SUBTITLE3: 'MEETING_SUBTITLE3',
  MEETING_BUTTON: 'MEETING_BUTTON',
  MEETING_BUTTON2: 'MEETING_BUTTON2',
  MEETING_BUTTON3: 'MEETING_BUTTON3',
  MEETING_SEARCH: 'MEETING_SEARCH',
  WEEK: 'WEEK',
  DAY: 'DAY',
  MONTH: 'MONTH',
  LIST: 'LIST',
  TITLE_ERROR: 'TITLE_ERROR',
  MEETING_MODAL_TITLE: 'MEETING_MODAL_TITLE',
  MEETING_MODAL_FIELD: 'MEETING_MODAL_FIELD',
  MEETING_MODAL_FIELD1: 'MEETING_MODAL_FIELD1',
  MEETING_MODAL_FIELD2: 'MEETING_MODAL_FIELD2',
  MEETING_MODAL_FIELD2_ERROR: 'MEETING_MODAL_FIELD2_ERROR',
  MEETING_MODAL_FIELD3: 'MEETING_MODAL_FIELD3',
  MEETING_MODAL_FIELD4: 'MEETING_MODAL_FIELD4',
  MEETING_MODAL_FIELD5: 'MEETING_MODAL_FIELD5',
  MEETING_MODAL_FIELD6: 'MEETING_MODAL_FIELD6',
  MEETING_MODAL_FIELD6_ERROR: 'MEETING_MODAL_FIELD6_ERROR',
  MEETING_MODAL_FIELD6_EXTERNAL: 'MEETING_MODAL_FIELD6_EXTERNAL',
  MEETING_MODAL_FIELD6_EXTERNAL_ERROR: 'MEETING_MODAL_FIELD6_EXTERNAL_ERROR',
  MEETING_MODAL_FIELD7: 'MEETING_MODAL_FIELD7',
  MEETING_MODAL_BUTTON: 'MEETING_MODAL_BUTTON',
  MEETING_MODAL_DELETE: 'MEETING_MODAL_DELETE',
  MEETING_MODAL_DELETE_CONFIRM: 'MEETING_MODAL_DELETE_CONFIRM',
  MEETING_MODAL_INFO: 'MEETING_MODAL_INFO',
  MEETING_MODAL_INFO1: 'MEETING_MODAL_INFO1',
  MEETING_MODAL_INFO2: 'MEETING_MODAL_INFO2',
  MEETING_MODAL_INFO3: 'MEETING_MODAL_INFO3',
  MEETING_MODAL_INFO4: 'MEETING_MODAL_INFO4',
  MEETING_MODAL_TITLE2: 'MEETING_MODAL_TITLE2',
  MEETING_MODAL_MESSAGE1: 'MEETING_MODAL_MESSAGE1',
  MEETING_MODAL_MESSAGE2: 'MEETING_MODAL_MESSAGE2',
  MEETING_MODAL_MESSAGE3: 'MEETING_MODAL_MESSAGE3',
  MEETING_MODAL_MESSAGE4: 'MEETING_MODAL_MESSAGE4',
  MEETING_MODAL_MESSAGE5: 'MEETING_MODAL_MESSAGE5',
  MEETING_MODAL_MESSAGE6: 'MEETING_MODAL_MESSAGE6',
  PROFILE_SUBTITLE2: 'PROFILE_SUBTITLE2',
  PROFILE_SUBTITLE3: 'PROFILE_SUBTITLE3',
  ROLE: 'ROLE',
  BUILDING: 'BUILDING',
  BUILDING2: 'BUILDING2',
  FIRSTNAME_ERROR: 'FIRSTNAME_ERROR',
  PASSWORD_ERROR: 'PASSWORD_ERROR',
  PROFILE_MESSAGE: 'PROFILE_MESSAGE',
  PROFILE_MESSAGE_DELETE: 'PROFILE_MESSAGE_DELETE',
  CONCIERGE_SUBTITLE2: 'CONCIERGE_SUBTITLE2',
  DOCUMENTS: 'DOCUMENTS',
  CONCIERGE_BUTTON: 'CONCIERGE_BUTTON',
  EVENT_SUBTITLE2: 'EVENT_SUBTITLE2',
  EVENT_SUBTITLE3: 'EVENT_SUBTITLE3',
  EVENT_SUBTITLE4: 'EVENT_SUBTITLE4',
  EVENT_SUBTITLE5: 'EVENT_SUBTITLE5',
  FREE: 'FREE',
  REGISTER: 'REGISTER',
  UNREGISTER: 'UNREGISTER',
  EVENT_MODAL_MESSAGE: 'EVENT_MODAL_MESSAGE',
  EVENT_MODAL_MESSAGE1: 'EVENT_MODAL_MESSAGE1',
  EVENT_MODAL_CONFIRM: 'EVENT_MODAL_CONFIRM',
  EVENT_MODAL_FIELD: 'EVENT_MODAL_FIELD',
  EVENT_MODAL_FIELD1: 'EVENT_MODAL_FIELD1',
  EVENT_MODAL_FIELD2: 'EVENT_MODAL_FIELD2',
  EVENT_MODAL_FIELD3: 'EVENT_MODAL_FIELD3',
  EVENT_MODAL_FIELD4: 'EVENT_MODAL_FIELD4',
  EVENT_MODAL_FIELD5: 'EVENT_MODAL_FIELD5',
  EVENT_MODAL_FIELD6: 'EVENT_MODAL_FIELD6',
  EVENT_MODAL_FIELD7: 'EVENT_MODAL_FIELD7',
  EVENT_MODAL_FIELD8: 'EVENT_MODAL_FIELD8',
  EVENT_MODAL_MESSAGE3: 'EVENT_MODAL_MESSAGE3',
  EVENT_MODAL_MESSAGE4: 'EVENT_MODAL_MESSAGE4',
  BEGINNING: 'BEGINNING',
  ENDING: 'ENDING',
  SEND: 'SEND',
  RESET_PASSWORD: 'RESET_PASSWORD',
  RESET_PASSWORD_MESSAGE: 'RESET_PASSWORD_MESSAGE',
  RESET_PASSWORD_MESSAGE2: 'RESET_PASSWORD_MESSAGE2',
  SIGNED_NDA: 'SIGNED_NDA',
  SIGNED_NDA2: 'SIGNED_NDA2',
  SIGNED_NDA3: 'SIGNED_NDA3',
  ROOM: 'ROOM',
  MY_FUTURE_RESERVATIONS_TITLE: 'MY_FUTURE_RESERVATIONS_TITLE',
  EXCEL_IMPORT: 'EXCEL_IMPORT',
};
